export default "__VITE_ASSET__81ef1268__"